'use client';

import { ComponentProps } from 'react';
import { useIntl } from 'react-intl';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import styles from './styles/styles.module.scss';

export type SearchBoxProps = Pick<
  ComponentProps<typeof AlgoliaSearchBox>,
  | 'clearOnSelect'
  | 'configs'
  | 'getCurrentLatLng'
  | 'navigateOnSelect'
  | 'onAddressSelect'
  | 'onInputBlur'
  | 'onInputFocus'
  | 'onNaturalLanguageResultSelect'
  | 'onResultSelect'
  | 'searchRequestLoading'
  | 'tertiaryElement'
  | 'value'
>;

const SearchBox = (searchProps: SearchBoxProps) => {
  const intl = useIntl();

  const placeholder = searchProps.onNaturalLanguageResultSelect
    ? intl.formatMessage({ defaultMessage: 'Search for anything' })
    : intl.formatMessage({ defaultMessage: 'Search' });

  return (
    <div className={styles.searchBox}>
      <AlgoliaSearchBox
        {...searchProps}
        dropdownVariant="enveloping"
        placeholder={placeholder}
        searchOrigin="global nav"
        searchTypes="all"
        showTrendingSuggestions
        variant="subtle"
        useTypeAhead
      />
    </div>
  );
};
export default SearchBox;
